import React, { useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { Typography, Box, Container, useTheme } from "@mui/material";
import {
  HomeOutlined,
  Schedule,
  Person,
  People,
  BarChart,
  Task,
  Call,
  AutoAwesomeMosaic as MachinModelIcon,
  Assignment,
  PictureInPicture,
  Notifications,
  TrendingUpTwoTone,
  GraphicEq,
  Grade,
  ChatSharp,
} from "@mui/icons-material";
import config from "../../app/config";

const Sidebar = (props) => {
  const { pathname } = useLocation();
  const { userInfo, userCurrentRole } = useSelector((state) => state.auth);
  const theme = useTheme();
  const [activeBar, setActiveBar] = useState("");
  const clientName = useSelector((state) => state.common.clientName);

  useEffect(() => {
    setActiveBar(pathname);
  }, [pathname]);

  const getClientNames = (clientName) => {
    switch (clientName) {
      case "danaire":
        return "DANAIRE";
      case "agelessind":
        return "AGELESS";
      case "clarity_dev":
        return "CLARITY DEV";
      case "clarity":
        return "CLARITY";
      case "froid":
        return "FROID";
      default:
        return null;
    }
  };

  const links = {
    ROLE_REGIONAL_SALES_MANAGER: [
      {
        title: "Dashboards",
      },
      {
        title: "National Service Hours",
        path: "/dashboard/last-4-years",
        icon: <BarChart />,
      },
      {
        title: "State Service Hours",
        path: "/",
        icon: <HomeOutlined />,
      },
      {
        title: "Last 12 months",
        path: "/dashboard/last-12-months",
        icon: <Schedule />,
      },
      {
        title: "Response / Resolution Times",
        path: "/dashboard/response-resolution",
        icon: <ChatSharp />,
      },
      {
        title: "Service Tickets",
      },
      {
        title: "By Customer",
        path: "/AllServiceTickets",
        icon: <AssignmentIndIcon />,
      },
      {
        title: "All Service Tickets",
        path: "/AllSvcTicketsForLastXdays",
        icon: <Assignment />,
      },
      {
        title: "Customer Ratings",
        path: "/customer-ratings",
        icon: <TrendingUpTwoTone />,
      },
      {
        title: "Data",
      },
      {
        title: "Customers",
        path: "/customers",
        icon: <People />,
      },
      {
        title: "Users",
        path: "/users",
        icon: <Person />,
      },
      {
        title: "Reports",
        path: "/reports",
        icon: <Task />,
      },

      { title: "Sales Calls", path: "/sales-calls", icon: <Call /> },
    ],

    ROLE_NATIONAL_SERVICE_MANAGER: [
      {
        title: "Dashboards",
      },
      {
        title: "National Service Hours",
        path: "/dashboard/last-4-years",
        icon: <BarChart />,
      },
      {
        title: "State Service Hours",
        path: "/",
        icon: <HomeOutlined />,
      },
      {
        title: "Last 12 months",
        path: "/dashboard/last-12-months",
        icon: <Schedule />,
      },
      {
        title: "Response / Resolution Times",
        path: "/dashboard/response-resolution",
        icon: <ChatSharp />,
      },
      {
        title: "Service Tickets",
      },
      {
        title: "By Customer",
        path: "/AllServiceTickets",
        icon: <AssignmentIndIcon />,
      },
      {
        title: "All Service Tickets",
        path: "/AllSvcTicketsForLastXdays",
        icon: <Assignment />,
      },
      {
        title: "Customer Ratings",
        path: "/customer-ratings",
        icon: <TrendingUpTwoTone />,
      },
      {
        title: "Data",
      },
      {
        title: "Users",
        path: "/users",
        icon: <Person />,
      },
      {
        title: "Reports",
        path: "/reports",
        icon: <Task />,
      },
      { title: "Sales Calls", path: "/sales-calls", icon: <Call /> },
    ],
    ROLE_SERVICE_COORDINATOR: [
      {
        title: "Dashboards",
      },
      {
        title: "National Service Hours",
        path: "/dashboard/last-4-years",
        icon: <BarChart />,
      },
      {
        title: "State Service Hours",
        path: "/",
        icon: <HomeOutlined />,
      },
      {
        title: "Last 12 months",
        path: "/dashboard/last-12-months",
        icon: <Schedule />,
      },
      {
        title: "Response / Resolution Times",
        path: "/dashboard/response-resolution",
        icon: <ChatSharp />,
      },
      {
        title: "Service Tickets",
      },
      {
        title: "By Customer",
        path: "/AllServiceTickets",
        icon: <AssignmentIndIcon />,
      },
      {
        title: "All Service Tickets",
        path: "/AllSvcTicketsForLastXdays",
        icon: <Assignment />,
      },
      // {
      //   title: "My Tickets",
      //   path: "/MyTickets",
      //   icon: <Assignment />,
      // },
      {
        title: "Paid Tickets",
        path: "/PaidTickets",
        icon: <AssignmentTurnedInIcon />,
      },
      {
        title: "Customer Ratings",
        path: "/customer-ratings",
        icon: <TrendingUpTwoTone />,
      },
      {
        title: "Data",
      },
      {
        title: "Customers",
        path: "/customers",
        icon: <People />,
      },
      {
        title: "Users",
        path: "/users",
        icon: <Person />,
      },
      {
        title: "Reports",
        path: "/reports",
        icon: <Task />,
      },
      {
        title: "Machine Models",
        path: "/machine-model",
        icon: <MachinModelIcon />,
      }
      ,
      {
        title: "Templates",
        path: "/templates",
        icon: <PictureInPicture />,
      },
     
      
      { title: "Sales Calls", path: "/sales-calls", icon: <Call /> },
      { title: "Notify", path: "/notify", icon: <Notifications /> },

     
      
    ],

    ROLE_DATA_OWNER: [
      {
        title: "Dashboards",
      },
      {
        title: "National Service Hours",
        path: "/dashboard/last-4-years",
        icon: <BarChart />,
      },
      {
        title: "State Service Hours",
        path: "/",
        icon: <HomeOutlined />,
      },
      {
        title: "Last 12 months",
        path: "/dashboard/last-12-months",
        icon: <Schedule />,
      },
      {
        title: "Response / Resolution Times",
        path: "/dashboard/response-resolution",
        icon: <ChatSharp />,
      },
      {
        title: "Service Tickets",
      },
      {
        title: "By Customer",
        path: "/AllServiceTickets",
        icon: <AssignmentIndIcon />,
      },
      {
        title: "All Service Tickets",
        path: "/AllSvcTicketsForLastXdays",
        icon: <Assignment />,
      },
      {
        title: "Customer Ratings",
        path: "/customer-ratings",
        icon: <TrendingUpTwoTone />,
      },
      {
        title: "Data",
      },
      {
        title: "Customers",
        path: "/customers",
        icon: <People />,
      },
      {
        title: "Users",
        path: "/users",
        icon: <Person />,
      },
      {
        title: "Reports",
        path: "/reports",
        icon: <Task />,
      },
      {
        title: "Machine Models",
        path: "/machine-model",
        icon: <MachinModelIcon />,
      },
      { title: "Sales Calls", path: "/sales-calls", icon: <Call /> },
      {
        title: "Templates",
        path: "/templates",
        icon: <PictureInPicture />,
      },
    ],
  };

  return (
    <div>
      {userInfo && (
        <Box component="nav" sx={{ width: { sm: props.drawerWidth }, flexShrink: { sm: 0 } }} aria-label="mailbox folders">
          <Drawer
            open
            variant="permanent"
            anchor="left"
            transitionDuration={500}
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: props.drawerWidth,
              },
            }}
          >
            <Box width="100%" height={"100vh"} sx={{ backgroundColor: theme.palette.primary.main, display: "flex", 
    flexDirection: "column", 
    overflowY: "auto" }}>
              <Box m="1rem">
                {/* <Box
                  sx={{ width: 200, resizeMode: "contain", marginLeft: -3, marginBottom: -7, marginTop: -2 }}
                  component="img"
                  src={getClientLogo(clientName)}
                  alt="logo"
                /> */}
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Typography fontSize="2rem" fontWeight="bold" color={"white"}>
                  {getClientNames(clientName)}
                  </Typography>
                </Box>
              </Box>
              <List>
                {userCurrentRole &&
                  links[userCurrentRole].map((link, index) =>
                    !link.icon ? (
                      <ListItem
                        key={link.title}
                        disablePadding
                        sx={{
                          pr: "2rem",
                          color: "white",
                        }}
                      >
                        <Typography key={link.title} sx={{ m: "1rem 0 1rem 1rem" }} variant="h5" fontWeight="600">
                          {link.title}
                        </Typography>
                      </ListItem>
                    ) : (
                      <ListItem
                        onClick={() => setActiveBar(link.path)}
                        component={RouterLink}
                        to={link.path}
                        key={index}
                        sx={{
                          textDecoration: "none",
                          color: "white",
                          backgroundColor: link.path === activeBar ? theme.palette.secondary.main : theme.palette.primary.main,
                        }}
                      >
                        <ListItemIcon sx={{ color: "white" }}>{link.icon}</ListItemIcon>
                        <ListItemText primary={link.title} />
                      </ListItem>
                    )
                  )}
              </List>
            </Box>
          </Drawer>
        </Box>
      )}
    </div>
  );
};

export default Sidebar;
